import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 1.6c-.43.01-.9.16-1.27.39q-.56.35-.9.88c-.13.22-.26.53-.32.76l-.01.08h-1.1c-1.2 0-1.21 0-1.35.09-.07.04-.16.14-.2.22s-.08.23-.06.33c.02.2.17.4.35.47l.1.04h2.26l.03.13q.18.7.71 1.21.63.62 1.52.75c1.32.2 2.62-.66 2.96-1.95l.04-.13h3.25c3.02-.01 3.26-.02 3.32-.04q.34-.15.39-.48c.03-.26-.13-.5-.38-.6-.05-.03-.55-.03-3.32-.04H8.51l-.04-.14c-.25-.93-1-1.66-1.94-1.9-.23-.06-.53-.09-.78-.08m-.14 1.16c-.55.1-1 .47-1.19 1-.09.23-.11.58-.06.84.19.91 1.17 1.46 2.04 1.14.5-.18.85-.58.99-1.1.02-.1.03-.17.03-.37 0-.3-.03-.42-.16-.68q-.23-.46-.7-.69l-.3-.12c-.18-.04-.49-.05-.65-.02m4.1 6.3q-.87.13-1.49.75-.5.52-.7 1.19l-.03.13H4.24l-3.26.01-.08.04c-.27.1-.42.4-.35.67q.06.26.32.38l.1.05h3.26l3.26.02.04.13c.25.93 1 1.66 1.94 1.9.41.1.9.1 1.3 0 .77-.2 1.4-.7 1.77-1.42.06-.13.16-.4.2-.54l.02-.08h1.13l1.14-.01.1-.04q.19-.1.29-.3c.04-.08.04-.11.04-.23 0-.11 0-.15-.04-.23-.06-.12-.19-.25-.31-.3l-.1-.04h-2.26l-.01-.07q-.18-.73-.73-1.27-.51-.51-1.2-.69c-.34-.09-.76-.11-1.1-.05m.29 1.11c-.6.06-1.1.42-1.31.96-.09.21-.1.33-.1.6 0 .3.02.42.15.68q.23.46.7.69c.25.13.38.16.69.15.2 0 .27 0 .37-.03.46-.13.84-.44 1.03-.86.1-.2.12-.33.13-.59.01-.27-.01-.42-.1-.64-.22-.53-.7-.88-1.27-.95-.13-.02-.18-.02-.29 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconFilter;
